class SilentLoginFailedException extends Error {
    public name = "SilentLoginFailedException";
    constructor(message: string) {
        super(message);
    }
}

export default SilentLoginFailedException;
